// extracted by mini-css-extract-plugin
export default {"error":"Location_error__Chbfg","back":"Location_back__670Or","logoBack":"Location_logoBack__f5ZGw","inputHeight":"Location_inputHeight__FDUUl","question":"Location_question__duTCw"};